import React from 'react';
import ReactGA from 'react-ga';
import { ReactComponent as Mail } from './mail.svg';
import { ReactComponent as Github } from './github.svg';
import { ReactComponent as Linkedin } from './linkedin.svg';
import { ReactComponent as Twitter } from './twitter.svg';
import { ReactGAEvents } from '../../utils/Constants';

// Icons taken from: https://simpleicons.org/

const components: Record<string, React.FunctionComponent<React.SVGProps<SVGSVGElement>>> = {
    mail    : Mail,
    github  : Github,
    linkedin: Linkedin,
    twitter : Twitter,
};

const SocialIcon = ({ kind, href, size = 8 }: { kind: string; href: string; size?: number }) => {
    if (!href || (kind === 'mail' && !/^mailto:\w+([.-]?\w+)@\w+([.-]?\w+)(.\w{2,3})+$/.test(href))) { return null; }

    const SocialSvg = components[kind];
    if (!SocialSvg) return null;

    const pxSize = size * 4;

    return (
        <a
            className="text-sm transition-colors duration-200"
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: `${pxSize}px`, height: `${pxSize}px` }}
            href={href}
            onClick={() => {
                ReactGA.event({
                    category: ReactGAEvents.ExternalLink,
                    action  : `Clicked External Link ${href}`,
                });
            }}
        >
            <span className="sr-only">{kind}</span>
            <SocialSvg
                className="fill-current text-neutral-600 hover:text-red-500 transition-colors duration-200"
                style={{ width: `${pxSize}px`, height: `${pxSize}px` }}
            />
        </a>
    );
};

export default SocialIcon;
